import { render, staticRenderFns } from "./PhoneTextPolicy.vue?vue&type=template&id=5617854b"
import script from "./PhoneTextPolicy.vue?vue&type=script&lang=js"
export * from "./PhoneTextPolicy.vue?vue&type=script&lang=js"
import style0 from "./PhoneTextPolicy.vue?vue&type=style&index=0&id=5617854b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports